
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[name]/territories",
      function () {
        return require("private-next-pages/[name]/territories.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[name]/territories"])
      });
    }
  